module.exports = __webpack_public_path__ + "img/arc-emblem.bd9ea85a.svg";